import ACA from '@components/pages/aca';

export default ACA;
